<template>
  <v-container class="pa-0">
    <v-data-table
      :search="search"
      :headers="headers"
      :items="cotizaciones"
      :items-per-page="20"
      :footer-props="{
        itemsPerPageText: 'El. por página',
        itemsPerPageAllText: 'Todo',
        itemsPerPageOptions: ippoptions,
      }"
      no-results-text="No hay resultados"
      no-data-text="No hay datos para mostrar"
      @click:row="detail"
    >
      <template v-slot:top>
        <v-text-field v-model="search" label="Buscar"></v-text-field>
      </template>
      <template v-slot:item.attributes.fecha_elaboracion="{ item }">
        <div>{{ item.attributes.fecha_elaboracion | date }}</div>
      </template>
      <template v-slot:item.attributes.nombre_cliente="{ item }">
        <div>{{ item.attributes.nombre_cliente | uppercase }}</div>
      </template>
      <template v-slot:item.attributes.total="{ item }">
        <div>{{ item.attributes.total | currency }}</div>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { httpGet } from "../../services/apiService";
export default {
  props: {
    clientID: String,
  },
  data() {
    return {
      overlay: false,
      search: "",
      headers: [
        {
          text: "Folio",
          align: "center",
          sortable: true,
          value: "attributes.folio",
        },
        {
          text: "Fecha",
          align: "center",
          sortable: true,
          value: "attributes.fecha_elaboracion",
        },
        {
          text: "Cliente",
          align: "center",
          sortable: true,
          value: "attributes.nombre_cliente",
        },
        {
          text: "Total",
          align: "center",
          sortable: false,
          value: "attributes.total",
        },
      ],
      ippoptions: [10, 20, 30, 40, 50, -1],
      cotizaciones: [],
    };
  },
  methods: {
    async getData() {
      const { data } = await httpGet(
        this.clientID != null ? this.queryByClient() : this.queryByRole()
      );
      (data?.data);
      this.cotizaciones = data?.data;
    },
    queryByRole() {
      const role = JSON.parse(sessionStorage.getItem("user"))["rol"];
      const id = JSON.parse(sessionStorage.getItem("user"))["id"];
      return role == "director" || role == "gerente"
        ? "/cotizaciones?populate=*&sort=fecha_elaboracion:desc"
        : `/cotizaciones?filters[vendedor][id][$eq]=${id}&populate=*&sort=fecha_elaboracion:desc`;
    },
    queryByClient() {
      return `/cotizaciones?filters[cliente][id][$eq]=${this.clientID}&populate=*&sort=fecha_elaboracion:desc`;
    },
    detail(event) {
      this.$router.push({ path: `/platform/cotizacion/${event.id}` });
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style>
</style>